import { gql, useQuery } from '@apollo/client'

const GET_PROGRAMS = gql`
query GetEnrolledPrograms {
  programEnrollments {
    program {
      id
      about
      achievements
      description
      image
      price
      organisationId
      duration
      durationMetric
      name
      programCourses {
        courseId
      }
    }
    status
  }
}
`;


const useFetchEnrolledPrograms = () => {
    const { data, loading, error } = useQuery(GET_PROGRAMS, {
        context: {
            headers: {
                'x-hasura-role': 'learner'
            }
        }
    });

    return { data: data?.programEnrollments, loading, error };
}

export default useFetchEnrolledPrograms;